import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6f61d35c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "main"
}
const _hoisted_2 = { class: "container" }
const _hoisted_3 = ["src"]
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { key: 0 }
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "link",
  href: "/"
}, "Začít znovu", -1))

import { computed, ref } from "vue";
import { useStore } from "vuex";
import { resultMessages } from "@cnf/textConfig";


export default /*#__PURE__*/_defineComponent({
  __name: 'ClapScreen',
  setup(__props) {

const store = useStore();

const isActive = ref(false);

store.subscribe((mutation) => {
  if (mutation.type === "submit") {
    isActive.value = true;
  }
});

const resultLogo = computed(() => {
  return require(`@/assets/${store.state.result}.svg`);
});
const resultMessage = computed(() => {
  return resultMessages[store.state.result];
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, null, {
    default: _withCtx(() => [
      (isActive.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("img", {
                src: _unref(resultLogo),
                draggable: "false"
              }, null, 8, _hoisted_3),
              _createElementVNode("h1", {
                innerHTML: _unref(resultMessage).title
              }, null, 8, _hoisted_4),
              (_unref(resultMessage).subtitle)
                ? (_openBlock(), _createElementBlock("h2", _hoisted_5, _toDisplayString(_unref(resultMessage).subtitle), 1))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(resultMessage).description, (p) => {
                return (_openBlock(), _createElementBlock("p", {
                  key: p,
                  innerHTML: p
                }, null, 8, _hoisted_6))
              }), 128))
            ]),
            _hoisted_7
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})